import { bingDashboardApi } from '../api/bingDashboard';
import { fmtInt, fmtNum, fmtPct } from './AppLikeDeliveryDashboard';
import { VooglamPerformanceDashboard, type DashboardFilter, type MetricField, type RtbDimension, type TrendMetric, type VooglamDashboardConfig } from './RtbDeliveryDashboard';

const DATE_DIMENSION: RtbDimension = { key: 'date', label: '日期', rowKey: 'date_label' };
const CAMPAIGN_DIMENSION: RtbDimension = { key: 'campaign_type', label: '广告系列', rowKey: 'campaign_type' };
const SEGMENTATION_DIMENSION: RtbDimension = { key: 'customer_segmentation', label: '受众细分', rowKey: 'customer_segmentation' };
const COUNTRY_DIMENSION: RtbDimension = { key: 'country', label: '国家/地区', rowKey: 'country' };

const BING_EFFICIENCY_METRICS: MetricField[] = [
  { key: 'spend', label: '账户花费', fmt: fmtNum, permKey: 'spend' },
  { key: 'ctr', label: '账户CTR', fmt: fmtPct },
  { key: 'cpc', label: '账户CPC', fmt: fmtNum, permKey: 'cpc' },
  { key: 'cost_per_add_to_cart', label: '单次加购费用', fmt: fmtNum, permKey: 'cpa' },
  { key: 'cpa', label: '账户CPA', fmt: fmtNum, permKey: 'cpa' },
  { key: 'aov', label: '账户单均价', fmt: fmtNum, permKey: 'revenue' },
  { key: 'account_roi', label: '账户ROI', fmt: fmtNum, permKey: 'roas' },
  { key: 'click_purchase_rate', label: '点击购买率', fmt: fmtPct },
  { key: 'click_add_to_cart_rate', label: '点击加购率', fmt: fmtPct },
  { key: 'purchase_conversion_rate', label: '购物车转化率', fmt: fmtPct },
  { key: 'impressions', label: '展示次数', fmt: fmtInt },
  { key: 'clicks', label: '点击次数', fmt: fmtInt },
  { key: 'add_to_cart_count', label: '加购次数', fmt: fmtInt },
  { key: 'purchases', label: '购物次数', fmt: fmtInt },
  { key: 'revenue', label: '购物转化价值', fmt: fmtNum, permKey: 'revenue' },
];

const BING_TREND_METRICS: TrendMetric[] = [
  { key: 'spend', label: '账户花费', fmt: fmtNum, permKey: 'spend', colorToken: '--primary', defaultSelected: true },
  { key: 'cpa', label: '账户CPA', fmt: fmtNum, permKey: 'cpa', colorToken: '--green', defaultSelected: true },
  { key: 'cpc', label: '账户CPC', fmt: fmtNum, permKey: 'cpc', colorToken: '--text3' },
  { key: 'click_purchase_rate', label: '点击购买率', fmt: fmtPct, colorToken: '--cyan', defaultSelected: true },
  { key: 'account_roi', label: '账户ROI', fmt: fmtNum, permKey: 'roas', colorToken: '--primary' },
  { key: 'click_add_to_cart_rate', label: '点击加购率', fmt: fmtPct, colorToken: '--green' },
  { key: 'purchase_conversion_rate', label: '购物车转化率', fmt: fmtPct, colorToken: '--text3' },
];

const TREND_FILTERS: DashboardFilter[] = [
  { key: 'campaign_type', label: '广告系列' },
];

const EFFICIENCY_FILTERS: DashboardFilter[] = [
  { key: 'campaign_type', label: '广告系列' },
  { key: 'customer_segmentation', label: '受众细分' },
  { key: 'country', label: '国家/地区', visibleForGrain: grain => grain !== 'day' },
];

function bingDimensionsForGrain(grain: 'day' | 'week' | 'month' | 'year'): RtbDimension[] {
  const base = [DATE_DIMENSION, CAMPAIGN_DIMENSION, SEGMENTATION_DIMENSION];
  return grain === 'day' ? base : [...base, COUNTRY_DIMENSION];
}

const VOOGLAM_BING_CONFIG: VooglamDashboardConfig = {
  platformLabel: 'Bing',
  reportKey: 'ad_dashboard_bing_v_overview',
  storageKey: 'vooglam_bing_dashboard_hidden_cols',
  getTrend: bingDashboardApi.getVooglamTrend,
  getEfficiency: bingDashboardApi.getVooglamOverview,
  labelDataset: 'vooglam_bing_delivery',
  trendFilters: TREND_FILTERS,
  efficiencyFilters: EFFICIENCY_FILTERS,
  dimensionsForGrain: bingDimensionsForGrain,
  efficiencyMetrics: BING_EFFICIENCY_METRICS,
  trendMetrics: BING_TREND_METRICS,
  efficiencyTitle: '投入效率-日期',
  campaignEfficiency: { title: '投入效率-广告系列维度', dimensions: ['campaign_type', 'date'] },
};

export default function VooglamBingDeliveryDashboard() {
  return <VooglamPerformanceDashboard config={VOOGLAM_BING_CONFIG} />;
}
